<section slimScroll contenteditable="true" class="scroll-window px-5 pt-2 sen-print-offer-general">
    <div class="border sen-fs12 p-2" [innerHTML]="translate.getLng('TERMS_AND_CONDITIONS')"></div>
</section>